import React, { useState } from 'react';
import { toast } from 'react-toastify';

import { useFreecodeContext } from 'hooks/useContext';
import ConfirmModal from 'components/Modals/confirmModal';
import { RectangleButton } from 'components/Button/rectangleButton';

export default function ResetSolution() {
  const { testImpl } = useFreecodeContext();

  const [resetting, setResetting] = useState(false);
  const [viewModal, setViewModal] = useState(false);

  const resetSolution = () => {
    setResetting(true);
    // TODO reset solution here...
    setTimeout(() => setResetting(false), 1000);
    console.log('should reset solution for testImpl', testImpl._id);
    toast.error('Resetting Solution Not Implemented!');
  };

  return (
    <RectangleButton small floatRight onClick={() => setViewModal(true)}>
      Reset Solution
      {viewModal && (
        <ConfirmModal
          title="Reset Solution"
          text="When resetting the solution all of your custom code will be lost. Do you want to continue?"
          onCancel={() => !resetting && setViewModal(false)}
          onConfirm={resetSolution}
          loading={resetting}
        />
      )}
    </RectangleButton>
  );
}
